'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_AppPageSize() {
}
export { $c_Lapp_api_AppPageSize as $c_Lapp_api_AppPageSize };
$p = $c_Lapp_api_AppPageSize.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_AppPageSize;
/** @constructor */
function $h_Lapp_api_AppPageSize() {
}
export { $h_Lapp_api_AppPageSize as $h_Lapp_api_AppPageSize };
$h_Lapp_api_AppPageSize.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lapp_api_AppPageSize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.api.AppPageSize", ({
  ie: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_api_AppPageSize as $d_Lapp_api_AppPageSize };
//# sourceMappingURL=app.api.-App-Page-Size.js.map
